import { render, staticRenderFns } from "./PicturesListEmpty.vue?vue&type=template&id=2dbd0c2e&"
import script from "./PicturesListEmpty.vue?vue&type=script&lang=js&"
export * from "./PicturesListEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports